module.exports = __webpack_public_path__ + "img/bl-active.e781afab.png";